import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import * as _ from "lodash";
import {
  getObjectGroupings,
  getScheduleProperties,
  updateProjectObjectDynamicProperties,
} from "../../helpers/axios/objectsAxios";
import {
  DATA_CHANGES,
  MODEL_DATA,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import LoadingScreen from "../loadingScreen/LoadingScreen";
import { getAllFluids } from "../../helpers/axios/fluidsAxios";
import { LoadProjectData } from "../../helpers/actions/RequestData";
import {
  agGridOptionsNone,
  agGridTheme,
} from "../../helpers/constants/Constants";
/* global Autodesk, THREE */ // eslint-disable-line

const Schedules = () => {
  const { modelData, modelDataLoaded, dataChanges, modelDataProjectId } =
    useSelector((state) => state.modelReducer);
  const {
    selectedProject,
    allDocs,
    cloudFiles,
    totalGlobalModels,
    numberOfLoadedGlobalModels,
  } = useSelector((state) => state.globalReducer);
  const [objectGroupings, setObjectGroupings] = useState(null);
  const [fluids, setFluids] = useState([]);

  const [selectedSchedule, setSelectedSchedule] = useState(null);
  // const [schedules, setSchedules] = useState([
  //   { display: "Valves", value: "Valve" },
  //   { display: "Actuated Valves", value: "Actuated Valve" },
  //   { display: "Pumps", value: "Pump" },
  // ]);

  const [gridColumns, setGridColumns] = useState(null);
  const [gridData, setGridData] = useState(null);
  const [gridApi, setGridApi] = useState();

  const [pendingChanges, setPendingChanges] = useState([]);

  let viewerApp;
  let viewer;

  const dispatch = useDispatch();
  // useEffect(() => {
  //   (async () => {
  //     //Load groups and set the first to be selected
  //     let tempObjectGroupings = await getObjectGroupings();
  //     setObjectGroupings(tempObjectGroupings);
  //     setSelectedSchedule(tempObjectGroupings[0].id);
  //   })();
  // }, []);

  useEffect(() => {
    if (allDocs?.length > 0 && cloudFiles?.length > 0) {
      LoadProjectData(
        dispatch,
        selectedProject,
        allDocs,
        cloudFiles,
        modelDataProjectId,
        modelData,
      );
    }
  }, [
    allDocs,
    cloudFiles,
    dispatch,
    modelData,
    modelDataProjectId,
    selectedProject,
  ]);

  //use effect to load fluids and set them to state
  useEffect(() => {
    (async () => {
      let tempFluids = await getAllFluids();
      setFluids(tempFluids);
    })();
  }, []);

  useEffect(() => {
    if (gridApi && gridData) {
      gridApi.autoSizeAllColumns();
    }
  }, [gridData, gridColumns]);

  useEffect(() => {
    (async () => {
      let tempColumns = [];
      let tempProps = null;
      tempProps = await getScheduleProperties(selectedSchedule);

      tempProps?.forEach((p) => {
        let tempCol = {
          field: p.property,
          cellDataType: false,
          resizable: true,
          editable: p.origin == "Dynamic",
          wrapHeaderText: true, // Wrap Text
          sort: p.property === "Tag Number" ? "asc" : null,
          // autoHeaderHeight: true, // Adjust Cell Height to Fit Wrapped Text
          width: 300,
          // cellStyle: (params) => (changeDetected(params) ? { color: "blue" } : { color: "black" }),
        };
        switch (p.type) {
          case "Dropdown":
            tempCol = {
              ...tempCol,
              cellEditor: "agRichSelectCellEditor",
              cellEditorParams: (params) => {
                let prop = fetchProperty(params.data, params.colDef.field);
                return { values: p.options.split(",") };
              },
            };
            break;
          case "Number":
            tempCol = {
              ...tempCol,
              cellEditor: "agNumberCellEditor",
            };
            break;
          case "Hyperlink":
            tempCol = {
              ...tempCol,
              cellRenderer: (params) => {
                const url = params.value;
                return (
                  <a
                    href={url}
                    className="text-info"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {url}
                  </a>
                );
              },
            };
            break;
          case "Fluid":
            tempCol = {
              ...tempCol,
              cellEditor: "agRichSelectCellEditor",
              cellEditorParams: (params) => {
                return {
                  values: fluids.map((o) => o.code + "-" + o.description),
                };
              },
            };
            break;
          default:
            break;
        }
        tempColumns.push(tempCol);
      });
      setGridColumns(tempColumns);
    })();
  }, [selectedSchedule]);

  useEffect(() => {
    (async () => {
      let tempData = [];
      modelData
        ?.filter((o) => o.category && o.category !== "Invalid MUID")
        .forEach((row) => {
          let tempRowData = { ...row };
          //Look into dataChanges to see if there are any changes since project load and overwrite the properties
          if (row.tag == "V01304") {
            let tempChangeTest = dataChanges.find(
              (o) => o.projectObjectId == row.projectObjectId,
            );
            let valveLocation = tempChangeTest?.properties.find(
              (o) => o.objectProperty.property == "Valve Location",
            );
          }
          let tempChange = dataChanges.find(
            (o) => o.projectObjectId == row.projectObjectId,
          );
          let tempProperties =
            tempChange != null ? tempChange.properties : row.properties;
          //Loop over every static object property
          for (let i = 0; i < tempProperties.length; i++) {
            const p = tempProperties[i];
            tempRowData = {
              ...tempRowData,
              [p.objectProperty.property]: p.objectProperty.value,
            };
          }
          // tempProperties.forEach((p) => {
          //   //Assign property to data for the grid
          //   tempRowData = {
          //     ...tempRowData,
          //     [p.objectProperty.property]: p.objectProperty.value,
          //   };
          // });
          tempData.push(tempRowData);
        });
      let tempObjectGroupings = await getObjectGroupings();
      const tempGroupingsFilter = tempObjectGroupings?.filter((o) => {
        return tempData?.find((m) => m.objectGroupingId == o.id) != null;
      });
      setObjectGroupings(tempGroupingsFilter);
      setSelectedSchedule(tempGroupingsFilter[0]?.id);
      //console log the tempData record with tag number V01304 to see if the valve location is being updated
      setGridData(tempData);
    })();
  }, [modelData]);

  const fetchProperty = (data, property) => {
    return data.properties.find(
      (prop) => prop.objectProperty.property == property,
    );
  };

  const changeDetected = (params) => {
    var data = params.data;
    var property = params.colDef.field;
    var value = params.value;
    return false;
    return (
      modelData
        .find((o) => o.projectObjectId == data.projectObjectId)
        .properties.find((p) => p.objectProperty.property == property)
        ?.objectProperty.value != value
    );
  };

  const onCellValueChanged = (event) => {
    //Update Local State
    var tempData = gridData;
    var tempRecord = tempData.find((o) => o.guid == event.data.guid);
    tempRecord[event.colDef.field] = event.newValue;
    setGridData(tempData);

    //Update Pending Changes
    var tempChanges = pendingChanges;
    var tempChangeRecord = tempChanges.find(
      (o) => o.guid == tempRecord.guid && o.property == event.colDef.field,
    );
    if (tempChangeRecord != null) {
      tempChangeRecord.value = event.newValue;
    } else {
      tempChanges.push({
        projectObjectId: tempRecord.projectObjectId,
        property: event.colDef.field,
        value: event.newValue,
        guid: tempRecord.guid,
        name: tempRecord.name,
        projectId: selectedProject[0].mviewProjectInfo.id,
      });
    }
    setPendingChanges(tempChanges);
  };

  const saveChanges = (event) => {
    //Update DB
    updateProjectObjectDynamicProperties(pendingChanges);
    //Clear Pending
    var tempModelData = _.cloneDeep(modelData);
    let tempDataChanges = _.cloneDeep(dataChanges);
    // for (let index = 0; index < tempGridData.length; index++) {
    //   const row = tempGridData[index];
    //   var tempChange = pendingChanges.find((o) => o.guid == row.guid);
    //   if (tempChange != null) {
    //     row[tempChange.property] = tempChange.value;
    //   }
    // }
    //loop over all pending changes and update the grid data
    for (let index = 0; index < pendingChanges.length; index++) {
      const change = pendingChanges[index];

      //Find the row and update the relevent property
      let rowData = _.cloneDeep(
        tempModelData.find((o) => o.guid === change.guid),
      );
      let prop = rowData.properties.find(
        (p) => p.objectProperty.property === change.property,
      );
      prop.objectProperty.value = change.value;

      //remove the data from tempModelData and add new rowData
      tempModelData = _.cloneDeep(
        tempModelData.filter((o) => o.guid !== change.guid),
      );
      tempModelData.push(rowData);

      //If the record is found dataChanges then update the value
      let tempChange = tempDataChanges.find(
        (o) => o.projectObjectId === change.projectObjectId,
      );
      if (tempChange != null) {
        //remove the property from the dataChanges
        // tempChange.properties = tempChange.properties.filter((o) => o.objectProperty.property !== change.property);

        //update the property value
        tempChange.properties.find(
          (o) => o.objectProperty.property === change.property,
        ).objectProperty.value = change.value;
      }

      // let rowData = tempModelData.find((o) => o.guid == change.guid);
      // for (let ii = 0; ii < tempModelData.length; ii++) {
      //   const rowData = tempModelData[ii];
      //   if (rowData.guid == change.guid) {
      //     //rowData.properties.find((p) => p.objectProperty.property == change.property).objectProperty.value = change.value;
      //     for (let iii = 0; iii < rowData.properties.length; iii++) {
      //       const prop = rowData.properties[iii];
      //       if (prop.objectProperty.property == change.property) {
      //         prop.objectProperty.value = change.value;
      //       }
      //     }
      //   }
      // }
    }

    setPendingChanges([]);

    dispatch(
      updateModelState({
        value: tempModelData,
        stateName: MODEL_DATA,
      }),
    );
    dispatch(
      updateModelState({
        value: tempDataChanges,
        stateName: DATA_CHANGES,
      }),
    );

    // gridApi.autoSizeAllColumns();
    //Update Redux State
  };

  const gridReady = (params) => {
    setGridApi(params.api);
    params.api.autoSizeAllColumns();
  };

  const gridRef = useRef(null);
  return (
    <>
      {!modelDataLoaded && (
        <LoadingScreen
          input="Fetching Project Data"
          position="fixed"
          width="20"
          marginTop="3%"
          showModelLoadProgress={true}
          numberOfLoadedGlobalModels={numberOfLoadedGlobalModels}
          totalGlobalModels={totalGlobalModels.length}
        />
      )}
      <div style={{ paddingLeft: "65px", paddingRight: "0px" }}>
        <div className="d-flex p-1 justify-content-end">
          <div className="me-auto">
            {objectGroupings?.map((group) => {
              return (
                <button
                  key={group.id}
                  className={
                    "btn btn-sm " +
                    (group.id == selectedSchedule
                      ? " mwh-btn-primary "
                      : " btn-primary ")
                  }
                  onClick={() => {
                    setSelectedSchedule(group.id);
                  }}
                >
                  {group.name}
                </button>
              );
            })}
          </div>
          <button onClick={saveChanges} className="btn btn-sm btn-success">
            Save Changes
          </button>
        </div>
        {gridColumns != null && gridData != null && (
          <div id="gridStyle" style={{ height: "70VH" }}>
            <AgGridReact
              theme={agGridTheme}
              ref={gridRef}
              rowData={gridData.filter(
                (o) => o.objectGroupingId === selectedSchedule,
              )}
              columnDefs={gridColumns}
              onGridReady={gridReady}
              suppressColumnVirtualisation={true}
              onCellValueChanged={onCellValueChanged}
              gridOptions={agGridOptionsNone}
              defaultColDef={{
                editable: false,
                // flex: 1,
                sortable: true,
                width: 300,
                filter: "agSetColumnFilter",
              }}
              cellSelection={{
                mode: "cell",
                handle: {
                  mode: "fill",
                  direction: "y",
                },
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Schedules;
